import { useGlobalContext } from "@utils/GlobalContext";
import {
  isComponentAllowedForLocale,
  isLocaleAllowed,
  isSlugAllowedForLocale,
} from "@utils/localeRestrictions";

/**
 * Convenience hook that binds locale-restriction predicates
 * to the current locale from GlobalContext.
 */
export const useLocaleRestriction = () => {
  const { locale } = useGlobalContext();

  return {
    locale,
    isAllowed: (allowedLocales?: readonly string[]) =>
      isLocaleAllowed(locale, allowedLocales),
    isSlugAllowed: (slug: string) => isSlugAllowedForLocale(slug, locale),
    isComponentAllowed: (componentKey: string) =>
      isComponentAllowedForLocale(componentKey, locale),
  };
};
